import React from 'react';
import type { FC } from 'react';
import { Key, useInput } from '@wix/cli-ui-kit';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { openBrowser } from '@wix/user-browser';
import { useSiteSelectorBi } from './bi.js';
import { getAppInstallUrl } from './development-site.js';

interface Props {
  siteId: string;
  appId: string;
}

export const OpenBrowser: FC<Props> = ({ siteId, appId }) => {
  const { t } = useTranslation();
  const bi = useSiteSelectorBi();

  useInput(async (input, key) => {
    if (key.return) {
      bi.cliAction({
        question: t('install_app_on_site.warning.instructions'),
        key: 'enter',
        action: 'install_app_on_site',
      });
      await openBrowser(getAppInstallUrl({ appId, siteId }));
    }
  });

  return (
    <>
      <Trans i18nKey="install_app_on_site.warning" />
      <Trans
        i18nKey="install_app_on_site.warning.instructions"
        components={[<Key value="Enter" />]}
      />
    </>
  );
};
